import { Component } from '@angular/core';

@Component({
	selector: 'app-iotemeter-site-energy-usage',
	templateUrl: './iotemeter-site-energy-usage.component.html',
})

export class IotemeterSiteEnergyUsageComponent {
}
